module.exports = __webpack_public_path__ + "img/alert-icon.595113e0.png";